<template>
  <v-container>
    <!-- barra -->
    <v-app-bar app absolute dark color="primary" elevation="3">
      <v-btn icon to="/">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <!-- TODO: traducir -->
      <v-toolbar-title>{{ t.config.opcionesUsuario }}</v-toolbar-title>
    </v-app-bar>
    <!-- contenido -->
    <v-content>
      <v-container class="px-0">
        <!-- panels -->
        <v-expansion-panels accordion focusable>
          <!-- datos de usuario -->
          <v-expansion-panel v-show="false">
            <v-expansion-panel-header
              :expand-icon="
                userAuth.uid === '__' ? 'error_outline' : 'expand_more'
              "
              :disable-icon-rotate="userAuth.uid === '__'"
            >
              <v-row>
                <v-col class="pl-2 py-0 flex-grow-0 flex-shrink-1">
                  <v-avatar size="32">
                    <img :src="userAuth.photo" />
                  </v-avatar>
                </v-col>
                <v-col class="pl-2 py-0 flex-grow-1 flex-shrink-0">
                  <div class="">
                    {{ userName }}
                    <br />
                    <span
                      class="caption"
                      :class="userAuth.uid ? 'blue-grey--text' : 'error--text'"
                    >
                      {{ userEmail }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-cuenta
                :enum.sync="userConfig._enum"
                :licencia="userLic"
                :user-data="userAuth"
              ></user-cuenta>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- mi perfil -->
          <v-expansion-panel>
            <v-expansion-panel-header
              :disable-icon-rotate="!okDatosPer"
              :expand-icon="okDatosPer ? 'expand_more' : 'error'"
            >
              <span>
                <v-icon class="mr-5">account_box</v-icon>
                {{ t.config.miPerfil }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-form v-model="okDatosPer" ref="datosPer">
                <user-datos-personales
                  :datos-personales.sync="userConfig.per"
                ></user-datos-personales>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- libro mdd -->
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="expand_more">
              <span>
                <v-icon class="mr-5">local_library</v-icon>
                {{ t.config.libroMdd }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-form v-model="okDatosMdd" ref="datosMdd">
                <user-libro-mdd :mdd.sync="userConfig.mdd"></user-libro-mdd>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- portadas mdd -->
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="expand_more">
              <span>
                <v-icon class="mr-5">photo_library</v-icon>
                {{ t.config.portadaMdd }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-libro-portadas
                :mdd.sync="userConfig.mdd"
              ></user-libro-portadas>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- cuaderno -->
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="expand_more">
              <span>
                <v-icon class="mr-5">playlist_add_check</v-icon>
                {{ t.cuaderno.deOracion }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-cuaderno :cuaderno.sync="userConfig.cua"></user-cuaderno>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- oracion mañana -->
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="expand_more">
              <span>
                <v-icon class="mr-5">wb_sunny</v-icon>
                {{ t.mdd.oracionManiana }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-oracion-maniana
                :oracion-maniana.sync="userConfig.orm"
                :mdd="userConfig.mdd"
              ></user-oracion-maniana>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- oracion noche -->
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="expand_more">
              <span>
                <v-icon class="mr-5">nights_stay</v-icon>
                {{ t.mdd.oracionNoche }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-oracion-noche
                :oracion-noche.sync="userConfig.orn"
                :mdd="userConfig.mdd"
              ></user-oracion-noche>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- tamaño letra -->
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="expand_more">
              <span>
                <v-icon class="mr-5">format_size</v-icon>
                {{ t.config.tamLetra }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-libro-apariencia :mdd.sync="userConfig.mdd">
              </user-libro-apariencia>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- ubicacion -->
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="expand_more">
              <span>
                <v-icon class="mr-5">place</v-icon>
                {{ t.config.ubicacion }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-ubicacion :ubicacion.sync="userConfig.ubi"></user-ubicacion>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- btn salir -->
        <v-row v-if="userAuth.uid !== '__'">
          <v-col>
            <v-btn text @click="signOut()">
              <v-icon left>exit_to_app</v-icon>
              {{ t.app.salir }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-container>
</template>

<script>
import appConfig from "../mixs/mixAppConfig.js";
import userConfig from "../mixs/mixUserConfig.js";
import UserCuenta from "./config/UserCuenta";
import UserDatosPersonales from "./config/UserDatosPersonales";
import UserUbicacion from "./config/UserUbicacion";
import UserLibroMdd from "./config/UserLibroMdd";
import UserLibroPortadas from "./config/UserLibroPortadas";
import UserCuaderno from "./config/UserCuaderno";
import UserOracionManiana from "./config/UserOracionManiana";
import UserOracionNoche from "./config/UserOracionNoche";
import UserLibroApariencia from "./config/UserLibroApariencia";

export default {
  name: "mdd-user",
  components: {
    UserCuenta,
    UserDatosPersonales,
    UserUbicacion,
    UserLibroMdd,
    UserLibroPortadas,
    UserCuaderno,
    UserOracionManiana,
    UserOracionNoche,
    UserLibroApariencia
  },
  mixins: [appConfig, userConfig],
  beforeRouteLeave(to, from, next) {
    // TODO: tambien antes de cerrar el navegador
    let oldC = this.oldConfig;
    let newC = JSON.stringify(this.newConfig);

    if (oldC !== newC) {
      this.$store.dispatch("user/valideAndSave", this.newConfig);
    }
    next();
  },
  mounted() {
    let lng = this.userConfig.mdd.lng;
    this.$store.dispatch("app/helpers/getPaises", lng);

    let pais = this.userConfig.ubi.pais;
    if (pais) this.$store.dispatch("app/helpers/getDeptos", pais);

    this.$set(this, "oldConfig", JSON.stringify(this.userConfig)); // para comparar
    this.$set(this, "newConfig", this.userConfig);
  },
  beforeUpdate() {
    // validar los formularios
    this.$refs.datosPer.validate();
    this.$refs.datosMdd.validate();
  },
  data() {
    return {
      oldConfig: "",
      newConfig: {},
      okDatosPer: true,
      okDatosMdd: true
    };
  },
  computed: {
    userAuth() {
      return this.$store.getters["user/auth"];
    },
    userName() {
      return this.userAuth.uid === "__"
        ? this.t.auth.userInvitado
        : this.userAuth.name;
    },
    userEmail() {
      return this.userAuth.uid === "__"
        ? this.t.auth.pendienteAct
        : this.userAuth.email;
    },
    userConfig() {
      return this.$store.getters["user/config"];
    },
    userLic() {
      return this.$store.getters["user/licenciaActiva"];
    }
  },
  methods: {
    signOut() {
      this.$fb.auth().signOut();
    },
    validarForms() {
      this.$refs.datosPer.validate();
    }
  }
};
</script>
